import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useRestrictedQueryParam = <T extends string>(paramName: string, allowedValues: T[], defaultValue?: T) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const paramValue = searchParams.get(paramName) as T;

  useEffect(() => {
    if (!allowedValues.includes(paramValue) && defaultValue) {
      setSearchParams(prevSearchParams => {
        prevSearchParams.set(paramName, defaultValue);
        return prevSearchParams;
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramName, allowedValues, defaultValue, paramValue]);

  return paramValue;
};
